var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1Ijoic21hcnRsaW5rZGV2IiwiYSI6ImNqc3Z2dHU5bjA4dWE0NHBqa3U4dnE0aTIifQ.Cctjg3CDUrjXHSBL_itBRA';
const buildEndpoint = (floorId) => {
    return `https://api.mapbox.com/datasets/v1/smartlinkdev/${floorId}/features?access_token=${MAPBOX_ACCESS_TOKEN}`;
};
const mergeMultipleDatasets = (datasets) => {
    const mergedDataset = {
        type: 'FeatureCollection',
        features: [],
    };
    datasets.forEach((dataset) => {
        mergedDataset.features = mergedDataset.features.concat(dataset.features);
    });
    return mergedDataset;
};
const getUrlFromLink = (link) => {
    const regex = /<([^>]+)>/;
    const match = link.match(regex);
    return match ? match[1] : undefined;
};
export const fetchMapboxDataset = (floorId) => __awaiter(void 0, void 0, void 0, function* () {
    let nextUrl = buildEndpoint(floorId);
    const allResponses = [];
    while (nextUrl) {
        try {
            const res = yield axios.get(nextUrl);
            const { data, headers } = res;
            allResponses.push(data);
            if (data.features.length < 1000) {
                break;
            }
            if (headers.link) {
                nextUrl = `${getUrlFromLink(headers.link)}&access_token=${MAPBOX_ACCESS_TOKEN}`;
            }
            else {
                nextUrl = undefined;
            }
        }
        catch (e) {
            console.log('err:', e);
            throw e;
        }
    }
    return mergeMultipleDatasets(allResponses);
});
//# sourceMappingURL=mapbox.js.map